
import { AuthContext, IUser } from '@sagecentral/core-ui';
import react, { useEffect, useState, useContext } from 'react';

const useCurrentUser = () => {
    const [ user, setUser ] = useState<IUser | null>(null);
    const auth = useContext(AuthContext);

    useEffect(() => {
        (async () => {
            const result: IUser | null = await auth.getUser() as IUser;
            setUser(result);
        })();
    }, [ auth ]);

    return user;
};

export default useCurrentUser;